import { UserService } from './../../core/user/user.service';
import { LoginForm } from '../models';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from "@angular/forms";
import { ChangeData } from "ngx-intl-tel-input";
import { OtpService } from './../services/otp.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { Location } from '@angular/common';
import { UtilsService } from 'src/app/core/services/utils.service';
import { FormStage } from 'src/app/account/enums/FormStage';
import { DefaultSettingService } from 'src/app/core/services/default-setting.service';
import { RoutingService } from 'src/app/home/services/routing.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { SessionStorageService } from 'src/app/shared/storage/session-storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {

  fgroup: UntypedFormGroup = this.fb.group({
    phoneNo: ['', Validators.compose([Validators.required])],
  });

  mobileNo: string = '';
  isInvalid: boolean = false;
  submitted = false;
  isSubmitting = false;
  telInpSetting = DefaultSettingService.telInpSetting;
  isFromHomePage: boolean = false;
  isFromCartPage: boolean = false;
  showContGuest: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private previousRouteService: PreviousRouteService,
    private location: Location,
    private utilService: UtilsService,
    private otpService: OtpService,
    private userService: UserService,
    private routingService: RoutingService,
    private storageService: StorageService,
    private navigationService: NavigationService,
    private sessionStorageService: SessionStorageService,
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.isFromHomePage = this.router.getCurrentNavigation().extras.state?.isFromHomePage;
      this.isFromCartPage = this.router.getCurrentNavigation().extras.state?.isFromCartPage;
      this.showContGuest = history?.state?.showContGuest ? history.state.showContGuest : false;
    }
  }

  async ngOnInit() {
    let phoneData = this.storageService.getCachedNumber();
    if (phoneData) {
      let phoneNo = this.formatPhoneNo(phoneData);
      let dialCode = phoneData.dialCode.replace('+', '');
      let parsedPhoneData = await this.utilService.parseGivenPhoneNumber("+" + dialCode + phoneNo);
      this.getFormControl('phoneNo').setValue(parsedPhoneData.nationalNumber);
    }

    this.mobileNo = history?.state?.mobileNo;
    if (this.mobileNo) {
      this.getFormControl('phoneNo').setValue(this.mobileNo);
    }

    this.getFormControl('phoneNo').valueChanges.subscribe((dt) => {
      this.isInvalid = false;
    })
  }

  private getFormControl(formControlName: string) {
    return this.fgroup.controls[formControlName];
  }

  onClickBack() {
    let backRoute = this.previousRouteService.getPaymentBackUrl();
    let previousURL = this.previousRouteService.getPreviousRoute();
    if (backRoute && !previousURL) {
      this.navigationService.navigateByUrl(backRoute);
    } else if (!backRoute && previousURL) {
      this.navigationService.navigateByUrl(previousURL.routeName, { replaceUrl: true });
      this.previousRouteService.removePreviousRoute();
    } else if (backRoute && previousURL) {
      this.navigationService.navigateByUrl(backRoute);
      this.previousRouteService.removePreviousRoute();
    }
    else {
      this.location.back();
    }

    this.sessionStorageService.removePaymentAndConfirmOrder();
  }

  private formatPhoneNo(phoneObj: ChangeData) {
    return phoneObj.e164Number ? phoneObj.e164Number.replace(phoneObj.dialCode || '', '') : '';
  }

  async onSubmit() {
    if (this.isSubmitting || this.submitted) {
      return;
    }

    this.isSubmitting = true;
    try {
      let phoneNo = this.getFormControl('phoneNo').value;
      if (phoneNo) {
        const mobile = phoneNo.e164Number;
        let isInvalid = await this.utilService.phoneNoValidation(mobile);
        if (!isInvalid) {
          await this.onClickLogin();
        } else {
          this.isInvalid = true;
        }
      }
    } finally {
      this.isSubmitting = false;
    }
  }

  async onClickLogin() {
    const loginForm: LoginForm = {
      dialCode: this.getFormControl('phoneNo').value.dialCode.replace('+', ''),
      phoneNo: this.formatPhoneNo(this.getFormControl('phoneNo').value),
      password: '',
      stage: FormStage.None,
      mobileObj: this.getFormControl('phoneNo').value,
      otpCode: '',
    };

    let phoneNoExist: boolean = false;
    let pwIsSet: boolean = false;
    let resp: any = await this.userService.getCustomerProfileStatus(loginForm.dialCode.replace('+', '') + loginForm.phoneNo, "");

    if (!(resp instanceof HttpErrorResponse)) {
      phoneNoExist = resp.mobileNumber ? true : false;
      pwIsSet = resp.passwordFlag ? resp.passwordFlag : false;
    }

    if (phoneNoExist && pwIsSet) {
      this.navigationService.navigate(["password-login"], { state: { data: loginForm, phoneNoExist: phoneNoExist }, replaceUrl: true });
    } else {
      await this.otpService.onSendOTP(loginForm.mobileObj);
      this.navigationService.navigate(["otp"], { state: { loginForm: loginForm, phoneNoExist: phoneNoExist, signupForm: !phoneNoExist }, replaceUrl: true });
    }

    this.submitted = true;
  }

  continueAsGuest() {
    let previousURL = this.previousRouteService.getPreviousRoute();
    if (previousURL) {
      this.navigationService.navigateByUrl(previousURL.routeName, { replaceUrl: true });
      this.previousRouteService.removePreviousRoute();
    } else {
      this.routingService.navigateHomeUrl();
    }

    this.sessionStorageService.removePaymentAndConfirmOrder();
  }
}

